import { render, staticRenderFns } from "./CancelStudent.vue?vue&type=template&id=0ff0fc49&"
import script from "./CancelStudent.vue?vue&type=script&lang=js&"
export * from "./CancelStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports